import type { InferRouterInputs, InferRouterOutputs, RouterClient } from "@orpc/server";

import { createORPCClient, onError } from "@orpc/client";
import { RPCLink } from "@orpc/client/fetch";
import { BatchLinkPlugin } from "@orpc/client/plugins";
import { createTanstackQueryUtils } from "@orpc/tanstack-query";
import { createIsomorphicFn } from "@tanstack/react-start";

import type router from "@/integrations/orpc/router";

import { getServerORPCClient } from "@/integrations/orpc/client.server";

export const getORPCClient = createIsomorphicFn()
  .server((): RouterClient<typeof router> => getServerORPCClient())
  .client((): RouterClient<typeof router> => {
    const link = new RPCLink({
      url: `${window.location.origin}/api/rpc`,
      fetch: (request, init) => fetch(request, { ...init, credentials: "include" }),
      plugins: [
        new BatchLinkPlugin({
          mode: typeof window === "undefined" ? "buffered" : "streaming",
          groups: [{ condition: () => true, context: {} }],
        }),
      ],
      interceptors: [
        onError((error) => {
          if (error instanceof DOMException && error.name === "AbortError") return;
          console.warn("[oRPC client]", error);
        }),
      ],
    });

    return createORPCClient(link);
  });

export const client = getORPCClient();

export const orpc = createTanstackQueryUtils(client);

export type RouterInput = InferRouterInputs<typeof router>;

export type RouterOutput = InferRouterOutputs<typeof router>;
